import { TaxScenario } from "./tax_scenario";
import { standardDeduction } from './standard_deduction';
import { totalIncome } from './total_income';

export function taxableIncome(taxScenario: TaxScenario): number {
  return Math.max(0, totalIncome(taxScenario) - standardDeduction(taxScenario) - taxScenario.qualifiedBusinessIncomeDeduction);
}
